<template>
  <div>
    <div class="headerButtons">
      <div class="headerButtons__backButton">
        <b-button variant="outline-primary" @click="goBack">
            Назад
        </b-button>
      </div>
    </div>
    <div class="studentsProgress">
      <!-- Заголовок -->
      <div class="studentsProgress__title d-flex justify-content-between flex-wrap">
        <h3>
          <em class="fas fa-tasks"></em>
          Отчет по тесту
        </h3>
        <div class="ml-auto text-right">
          <b-button
            variant="primary"
            class="mb-2 ml-2"
            title="Экспорт для выбранной организации"
            @click="exportTestResults">
            <em class="fas fa-file-excel mr-1"></em> Экспорт для выбранной
          </b-button>
          <b-button
            class="mb-2 ml-2"
            v-if="hasRole('curator')"
            variant="primary"
            title="Экспорт для всех организаций"
            @click="exportTestResultsAll">
            <em class="fas fa-file-excel mr-1"></em> Экспорт для всех
          </b-button>
        </div>
      </div>
      <!-- Фильтры -->
      <div class="studentsProgress__filters">
        <b-form-select
          v-model="selectedOrg"
          :options="optionsOrg"
          v-b-tooltip.hover
          title="Организация"
          class="studentsProgress__filters-organisation"
          @change="onFiltersChange"
        >
        </b-form-select>
        <b-form-select
          v-model="selectedClass"
          :options="optionsClass"
          v-b-tooltip.hover
          title="Класс"
          class="studentsProgress__filters-class"
          @change="onFiltersChange"
        >
        </b-form-select>
      </div>
      <!-- Таблица -->
      <div class="studentsProgress__table" ref="gridDiv">
        <ag-grid-vue
          style="width: 100%; height: 100%;"
          class="ag-theme-material ag-grid-vue-progress"
          rowHeight="50"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          :rowData="studentsReports"
          :suppressPaginationPanel="true"
          :frameworkComponents="frameworkComponents"
          :context="context"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
        >
        </ag-grid-vue>
      </div>
    </div>
    <report-modal @markUpdated="onMarkUpdated" />
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import ReportRenderer from '@/components/helpers/renderers/ReportRenderer'
import TestAPI from '@/api/test'

import ReportModal from '@/components/content/education/courses/modals/ReportModal.vue'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import { roles } from '@/config/roles'
import { typeTranslates } from '@/config/content/types'


export default {
  name: 'TestStudentsProgress',
  components: {
    'ag-grid-vue': AgGridVue,
    ReportModal
  },
  props: {
    editMode: Boolean
  },
  data() {
    return {
      optionsClass: [
        { value: ['10', '11'], text: 'Все классы' },
        { value: ['10'], text: '10 класс' },
        { value: ['11'], text: '11 класс' }
      ],
      selectedOrg: null,
      selectedClass: ['10', '11'],
      frameworkComponents: {
        reportRenderer: ReportRenderer
      },
      columnDefs: [
        {
          headerName: 'Фамилия',
          field: 'surname',
          sortable: true,
          headerClass: 'ag-grid-table-header'
        },
        {
          headerName: 'Имя',
          field: 'name',
          sortable: true,
          headerClass: 'ag-grid-table-header'
        },
        {
          headerName: 'Отчество',
          field: 'midname',
          sortable: true,
          headerClass: 'ag-grid-table-header'
        },
        {
          headerName: 'Правильных ответов',
          field: 'correctAnswers',
          sortable: true,
          headerClass: 'ag-grid-table-header',
          valueFormatter: this.solvedFormatter,
          valueGetter: this.correctAnswersVGetter
        },
        {
          headerName: 'Оценка',
          field: 'mark',
          sortable: true,
          suppressSizeToFit: true,
          width: 120,
          headerClass: 'ag-grid-table-header',
          valueFormatter: this.marksFormatter,
          valueGetter: this.marksVGetter
        },
        {
          headerName: 'Отчет',
          field: 'report',
          sortable: false,
          suppressSizeToFit: true,
          width: 100,
          headerClass: 'ag-grid-table-header',
          cellRenderer: 'reportRenderer'
        }
      ],
      gridApi: null,
      columnApi: null,
      autoGroupColumnDef: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: false
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      context: {
        componentParent: this
      },
      rowGroupPanelShow: null,
      pivotPanelShow: null,
      correctAnswers: [],
      incorrectAnswers: [],
      mark: 0,
      userId: 0
    }
  },
  computed: {
    ...mapGetters({
      currUser: 'currentUser/getCurrentUser',
      hasRole: 'currentUser/hasRole',
      orgs: 'dicts/getOrganizations',
      studentsReports: 'educationStudentsManagement/getTestProgress',
      courseContent: 'education/getCourseContent',
      courseSubsectionsStructure: 'education/getCourseSubsectionsStructure'
    }),
    optionsOrg() {
      if (this.orgs && this.orgs.length) {
        if (this.hasRole(roles.curator)) {
          return this.orgs
            .filter((org) => org.type === typeTranslates.class || org.type === typeTranslates.spo)
            .sort((org1, org2) => (org1.text > org2.text ? 1 : -1))
            .map((org) => ({
              value: org.id,
              text: org.title
            }))
        }
        if (this.hasRole(roles.teacher)) {
          return [{
            value: this.currUser.organizationId,
            text: this.orgs.find((p) => p.id === this.currUser.organizationId).title
          }]
        }
      }

      return []
    }
  },
  created() {
    if (!this.courseContent) {
      this.fetchCourseContent({
        id: this.$route.params.courseBookId,
        all: false
      })
    }
    this.selectedOrg = this.orgs.find((p) => p.id === this.currUser.organizationId).id
    if (!this.optionsOrg.find((option) => option.value === this.selectedOrg)) {
      this.selectedOrg = this.optionsOrg.length ? this.optionsOrg[0].value : null
    }
    this.fetchStudentsProgress({
      testId: this.$route.params.sectionId,
      classes: this.selectedClass,
      organizationId: this.selectedOrg
    })
  },
  methods: {
    goBack() {
      //this.clearCourseContent();
      this.$router.go(-1);
    },
    solvedFormatter(params) {
      if (params.data.userTests.length > 0) {
        const answers = Object.entries(params.data.userTests[0].progress)
        return `${answers.filter((a) => a[1].isCorrect === true).length} / ${answers.length}`
      }

      return '-'
    },
    correctAnswersVGetter(params) {
      if (params.data.userTests.length > 0) {
        const answers = Object.entries(params.data.userTests[0].progress)
        if (answers) {
          return answers.filter((a) => a[1].isCorrect === true).length > 0
            ? answers.filter((a) => a[1].isCorrect === true).length
            : 1
        }

        return 0
      }

      return 0
    },
    marksFormatter(params) {
      return params.data.userTests.length > 0
        ? params.data.userTests[0].mark : '-'
    },
    marksVGetter(params) {
      return params.data.userTests.length > 0
        ? params.data.userTests[0].mark : 0
    },
    ...mapMutations({
      setReportId: 'educationStudentsManagement/setReportId',
      setCourseContent: 'education/setCourseContent'
    }),
    ...mapActions({
      clearCourseContent: 'education/clearCourseContent',
      fetchStudentsProgress: 'educationStudentsManagement/fetchTestStudentsProgress',
      fetchCourseContent: 'education/fetchCourseContent'
    }),
    exportTestResults() {
      TestAPI.exportTestResultsExcel(this.$route.params.sectionId, this.selectedClass, this.selectedOrg)
    },
    exportTestResultsAll() {
      TestAPI.exportTestResultsExcel(this.$route.params.sectionId, this.selectedClass, 'all')
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      if (this.$refs.gridDiv.clientWidth >= 1300) {
        this.gridApi.sizeColumnsToFit()
      }
      this.gridWidth = this.$refs.gridDiv.clientWidth
    },
    onGridSizeChanged() {
      if ((this.$refs.gridDiv.clientWidth >= 1300
            && this.$refs.gridDiv.clientWidth > this.gridWidth)
            || (this.$refs.gridDiv.clientWidth >= 1500)) {
        this.gridApi.sizeColumnsToFit()
      }
      this.gridWidth = this.$refs.gridDiv.clientWidth
    },
    onFiltersChange() {
      this.fetchStudentsProgress({
        testId: this.$route.params.sectionId,
        classes: this.selectedClass,
        organizationId: this.selectedOrg
      })
    },
    onParentReportClicked(data) {
      this.setReportId(data.userTests[0].userId)
      this.$bvModal.show('reportModal')
    },
    onMarkUpdated() {
      this.fetchStudentsProgress({
        testId: this.$route.params.sectionId,
        classes: this.selectedClass,
        organizationId: this.selectedOrg
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.headerButtons {
  width: 100%;
  padding: 20px 0 5px 0;
}

.studentsProgress {

  div {
    margin-top: 15px;
  }

  &__filters {
    width: 100%;

    &-organisation {
      width: 78%;
    }

    &-class {
      float: right;
      width: 20%;
    }
  }

  &__table {
    height: calc(100vh - 330px);
    border-bottom: 1px solid lightgray;
  }

  &__paginator {
    position: relative !important;
    text-align: right !important;
  }

}

</style>
